'use client'
import React, {useEffect, useState } from 'react'
import { PrismicText } from '@prismicio/react'
import { PrismicNextImage } from '@prismicio/next'
import { createClient } from '../prismicio'
import NextLink from 'next/link'
import PlayButton  from '../assets/images/icons/play-button.svg'

interface InfoPanelProps {
    data?: any | null;
  }
  
  const InfoPanel:React.FC<InfoPanelProps>  =({ data })=> {

  const [infoPanel, setInfoPanel] = useState(null) as any
  const uid = data;

//   console.log(uid)
  
  useEffect(() => {
    const fetchInfoPanel = async () => {
        const client = createClient()
        const response = await client.getByUID('section', uid) as any
        if (response) {
            return setInfoPanel(response);
        }
    }
    fetchInfoPanel();
  }, [uid])

if(infoPanel) {
    return (
        <NextLink href={"/"+infoPanel.uid} className="relative w-full block mb-8 md:mb-0" aria-label={infoPanel.data?.page_title?.[0]?.text ?? 'Learn more'}>
            <span role="presentation" aria-hidden="true" className="absolute left-[43%] top-[30%] z-10 p-2 bg-jade/60 rounded-full flex items-center justify-center">
                <PlayButton className="relative left-0.5"/>
            </span>
            {infoPanel.data.meta_image && infoPanel.data.meta_image.url ? 
                <PrismicNextImage field={infoPanel.data.meta_image} fallbackAlt="" className="w-full aspect-video object-cover" sizes="(min-width: 768px) 50vw, 100vw"/>
                : 
                <div className="placeholder"></div>
            }
            <p className="text-[12px] text-white mt-4"><PrismicText field={infoPanel.data.page_title}/></p>
        </NextLink>
    )
}
else {
    return null;
}
}

export default InfoPanel;
